module.exports = __webpack_public_path__ + "img/completed.469558ca.png";